/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

xplenty.directive('datetimePicker', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/datetime-picker.html'),

      replace: true,

      scope: {
        fulldate: '=ngModel',
      },

      link(scope, element, attrs) {
        const setFulldate = function () {
          scope.fulldate = moment.utc(angular.extend(scope.date, scope.time)).toISOString();
        };
        scope.$watch('date', setFulldate, true);
        scope.$watch('time', setFulldate, true);
      },
      controller: [
        '$scope',
        function ($scope) {
          const fulldate = moment.utc($scope.fulldate);

          $scope.date = {
            day: fulldate.date(),
            month: fulldate.month(),
            year: fulldate.year(),
          };

          $scope.time = {
            hour: fulldate.hour(),
            minute: fulldate.minute(),
          };
        },
      ],
    };
  },
]);
